import React from "react";
import CustomTableCell from "../controls/CustomTableCell";

const NoItemsTableCell = () => (
  <CustomTableCell colSpan={6} style={{ padding: 20, textAlign: "center" }}>
    <strong>No hay productos en el Carrito</strong>
  </CustomTableCell>
);

export default NoItemsTableCell;
